import { ChangePasswordRequest } from 'src/models/user';
import axiosInstance from 'src/utils/axios';

const meService = {
  logUserIn: async (): Promise<void> => {
    try {
      await axiosInstance.post('/api/me/logged-in', {});
    } catch (error) {
      console.error('Error logging in user:', error);
      throw error;
    }
  },

  changePassword: async (
    changePasswordRequest: ChangePasswordRequest
  ): Promise<{ success: boolean; message: string }> => {
    try {
      const response = await axiosInstance.put('/api/me/change-password', changePasswordRequest);
      return { success: true, message: response.data };
    } catch (error) {
      console.error('Error changing password:', error);
      return { success: false, message: error.response?.data || 'An error occurred' };
    }
  },
};

export default meService;
